{
  "name": "supersee",
  "version": "5.0.3",
  "scripts": {
    "ng": "ng",
    "postinstall": "patch-package && node scripts/patch-peerjs.js && node scripts/generate-all-env.js",
    "prebuild": "node scripts/generate-env.js development",
    "prebuild:local": "node scripts/generate-env.js local",
    "prebuild:prod": "node scripts/generate-env.js production",
    "prebuild:staging": "node scripts/generate-env.js staging",
    "prebuild:demo": "node scripts/generate-env.js demo && node scripts/materialize-demo-firebase-sw.js",
    "prebuild:demo:host": "node scripts/generate-env.js demo:host && node scripts/materialize-demo-firebase-sw.js",
    "prebuild:demo:local": "node scripts/generate-env.js demo:local && node scripts/materialize-demo-firebase-sw.js",
    "prestart": "node scripts/generate-env.js development",
    "prestart:local": "node scripts/generate-env.js local",
    "prestart:prod": "node scripts/generate-env.js production",
    "prestart:staging": "node scripts/generate-env.js staging",
    "prestart:demo": "node scripts/generate-env.js demo && node scripts/materialize-demo-firebase-sw.js",
    "start": "ng serve --port=4201",
    "start:local": "ng serve --configuration=local --port=4200",
    "start:prod": "ng serve --configuration=production --port=4201",
    "start:staging": "ng serve --configuration=staging --port=4203",
    "start:demo": "ng serve --configuration=demo --port=4204",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "build:staging": "ng build --configuration staging",
    "build:demo": "ng build --configuration demo",
    "build:demo:host": "ng build --configuration demo",
    "build:demo:local": "ng build --configuration demo",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.0",
    "@angular/cdk": "^20.0.0",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/fire": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/material": "^20.0.0",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.0.0",
    "@angular/router": "^20.0.0",
    "@angular/service-worker": "^20.0.0",
    "@betahuhn/feedback-js": "^2.1.25",
    "@ngx-loading-bar/core": "^6.0.2",
    "@ngx-loading-bar/http-client": "^6.0.2",
    "@ngx-loading-bar/router": "^6.0.2",
    "chart.js": "^4.4.4",
    "chartjs-plugin-annotation": "^3.1.0",
    "chartjs-plugin-autocolors": "^0.2.2",
    "chartjs-plugin-zoom": "^2.0.1",
    "file-saver": "^2.0.5",
    "firebase": "^11.8.0",
    "flag-icons": "^7.5.0",
    "google-libphonenumber": "^3.2.40",
    "hammerjs": "^2.0.8",
    "html2canvas": "^1.4.1",
    "jquery": "^3.7.0",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^3.8.2",
    "leaflet": "^1.9.4",
    "luxon": "^3.4.4",
    "mat-select-autocomplete": "^1.3.0",
    "materialize-css": "^1.0.0-rc.2",
    "moment": "^2.29.1",
    "ng-recaptcha": "^13.2.1",
    "ng2-tooltip-directive": "^2.10.3",
    "ngx-avatars": "^1.7.0",
    "ngx-countries-dropdown": "^2.1.2",
    "ngx-skeleton-loader": "^6.0.0",
    "ngx-timeago": "^3.0.0",
    "ngx-ui-tour-core": "^16.0.0",
    "ngx-ui-tour-md-menu": "^16.0.0",
    "papaparse": "^5.4.1",
    "peerjs": "^1.5.1",
    "platform": "^1.3.6",
    "rxjs": "^7.8.0",
    "sweetalert2": "^10.10.4",
    "tslib": "^2.0.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^20.0.0",
    "@angular-devkit/build-angular": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@angular/language-service": "^20.0.0",
    "@playwright/test": "^1.58.2",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "^3.3.8",
    "@types/jasminewd2": "^2.0.3",
    "@types/jquery": "^3.5.16",
    "@types/leaflet": "^1.9.20",
    "@types/node": "^20.0.0",
    "autoprefixer": "^10.4.23",
    "codelyzer": "^5.1.2",
    "crypto-js": "^4.2.0",
    "dotenv": "^17.2.3",
    "jasmine-core": "^3.5.0",
    "jasmine-spec-reporter": "^5.0.0",
    "karma": "^6.4.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-coverage-istanbul-reporter": "^3.0.2",
    "karma-jasmine": "^4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "mysql2": "^3.20.0",
    "patch-package": "^8.0.1",
    "postcss": "^8.5.6",
    "protractor": "^7.0.0",
    "tailwindcss": "^3.4.19",
    "ts-node": "^7.0.0",
    "tslint": "^6.1.0",
    "typescript": "~5.8.0"
  }
}